// Partner CRM — Investitori — client API.
// Riusa l'istanza axios centrale (Bearer + refresh 401).
import { api, unwrap } from './client';

export const investorsService = {
  // ---------------- ADMIN ----------------
  adminListPartners: () => unwrap(api.get('/investors/admin/partners')),
  adminCreatePartner: (body) => unwrap(api.post('/investors/admin/partners', body)),
  adminUpdatePartner: (id, body) => unwrap(api.patch(`/investors/admin/partners/${id}`, body)),
  adminDeletePartner: (id) => unwrap(api.delete(`/investors/admin/partners/${id}`)),

  adminListDocuments: () => unwrap(api.get('/investors/admin/documents')),
  adminUploadDocument: (formData) => unwrap(api.post('/investors/admin/documents', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })),
  adminUpdateDocument: (id, body) => unwrap(api.patch(`/investors/admin/documents/${id}`, body)),
  adminDeleteDocument: (id) => unwrap(api.delete(`/investors/admin/documents/${id}`)),

  adminGetMetrics: (target = 'all') => unwrap(api.get('/investors/admin/metrics', { params: { target } })),
  adminSaveMetrics: (body) => unwrap(api.put('/investors/admin/metrics', body)),

  // ---------------- INVESTITORE (sola lettura) ----------------
  me: () => unwrap(api.get('/investors/me')),
  myDocuments: () => unwrap(api.get('/investors/documents')),
  myMetrics: () => unwrap(api.get('/investors/metrics')),
  updateBranding: (body) => unwrap(api.put('/investors/me/branding', body)),

  // ---------------- PUBBLICO ----------------
  publicPartners: () => unwrap(api.get('/investors/public/partners')),

  // Download AUTORIZZATO (blob): il token Bearer viaggia negli header axios.
  download: async (docId, filename = 'documento') => {
    const res = await api.get(`/investors/documents/${docId}/download`, { responseType: 'blob' });
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  },
};

export default investorsService;
